import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const DefendMyNoteBanner = ({ user }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!user?.subscriptionExpires) {
      console.log('No subscription expiry date found');
      return;
    }

    // Calculate days since subscription started
    // Subscription expires date is 365 days after start, so subtract 365 days to get start date
    const subscriptionStartDate = new Date(user.subscriptionExpires);
    subscriptionStartDate.setDate(subscriptionStartDate.getDate() - 365);
    
    const today = new Date();
    const daysFromSubscription = Math.floor((today - subscriptionStartDate) / (1000 * 60 * 60 * 24));
    
    console.log('Subscription start date:', subscriptionStartDate);
    console.log('Days from subscription:', daysFromSubscription);
    
    // Show banner if within first 30 days
    setIsVisible(daysFromSubscription <= 30);
  }, [user]);

  const handleDismiss = () => {
    // Only hide for current session, will show again on next login
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="relative bg-green-50 border-b border-green-200">
      <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
        <div className="pr-16 sm:text-center">
          <p className="font-medium text-green-900">
            <span className="inline">
              Finish ER notes faster with Defend My Note (
              <a href="https://www.defendmynote.com" target="_blank" rel="noopener noreferrer" className="underline">
                www.defendmynote.com
              </a>
              ). Use <span className="font-bold">CRITICALCASES10</span> for 10% off at checkout!
            </span>
          </p>
        </div>
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
          <button
            type="button"
            className="flex p-2 rounded-md hover:bg-green-100 focus:outline-none"
            onClick={handleDismiss}
          >
            <X className="h-5 w-5 text-green-500" aria-hidden="true" />
            <span className="sr-only">Dismiss</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DefendMyNoteBanner;